exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".event-btn-note {\n  width: 180px;\n  height: 45px;\n  border-radius: 30px;\n  background-color: #133f7e;\n  text-align: center;\n  color: #eff3f6;\n  font-size: 14px;\n  font-weight: 900; }\n\n.event-latest {\n  height: 150px; }\n\n.table-responsive {\n  overflow-x: auto;\n  white-space: nowrap; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/user/events/events.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/user/events/events.css
// module chunks = 0